import React from "react";
import { Button, Select } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { AGENT_MASTER_EDITABLE_CONTAINER_STATUSES } from "../../config/agentPortal";
import {
  AGENT_FILTER_SELECT_PROPS,
  AgentFilterToolbar,
} from "./AgentFilterToolbar";

interface AgentMasterContainersFiltersProps {
  search: string;
  transportFilter?: number;
  transportTypes: { id: number; name: string }[];
  hasActiveFilters: boolean;
  resultCount: number;
  onSearchChange: (value: string) => void;
  onTransportChange: (value?: number) => void;
  onClearFilters: () => void;
  onRefresh: () => void;
  onAdd: () => void;
}

export const AgentMasterContainersFilters: React.FC<
  AgentMasterContainersFiltersProps
> = ({
  search,
  transportFilter,
  transportTypes,
  hasActiveFilters,
  resultCount,
  onSearchChange,
  onTransportChange,
  onClearFilters,
  onRefresh,
  onAdd,
}) => (
  <AgentFilterToolbar
    search={search}
    searchPlaceholder="Search reference or transport…"
    onSearchChange={onSearchChange}
    hasActiveFilters={hasActiveFilters}
    onClearFilters={onClearFilters}
    onRefresh={onRefresh}
    resultCount={resultCount}
    actions={
      <Button size="small" type="primary" icon={<PlusOutlined />} onClick={onAdd}>
        Add Master BL/AWB
      </Button>
    }
  >
    <Select
      {...AGENT_FILTER_SELECT_PROPS}
      placeholder="Transport"
      value={transportFilter}
      onChange={onTransportChange}
      options={transportTypes.map((t) => ({ value: t.id, label: t.name }))}
    />
  </AgentFilterToolbar>
);

export const AGENT_MASTER_STATUS_TABS = [
  { key: "all", label: "All" },
  ...AGENT_MASTER_EDITABLE_CONTAINER_STATUSES.map((s) => ({
    key: s.value,
    label: s.label,
  })),
] as const;
